module.exports = __webpack_public_path__ + "img/cp4-2.e971f8ab.jpg";